import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { RubberBandNS } from "../../../../../../RubberBand/RubberBandNS.js";
import { SelectorNS } from "../../../../../../Selector/SelectorNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { TransformNS } from "../../../../../../Transform/TransformNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
import { _handleMouseDownOnCanvasEl } from "../private/_handleMouseDownOnCanvasEl.js";
import { _handleMouseDownOnSelectorPathEl } from "../private/_handleMouseDownOnSelectorPathEl.js";
import { _handleMouseDownOnSelectorRotateCircleEl } from "../private/_handleMouseDownOnSelectorRotateCircleEl.js";
import { _handleMouseDownOnSelectorScaleCircleEl } from "../private/_handleMouseDownOnSelectorScaleCircleEl.js";
import { _handleMouseDownOnSelectorScaleNECircleEl } from "../private/_handleMouseDownOnSelectorScaleNECircleEl.js";
import { _handleMouseDownOnSelectorScaleNWCircleEl } from "../private/_handleMouseDownOnSelectorScaleNWCircleEl.js";
import { _handleMouseDownOnSelectorScaleSECircleEl } from "../private/_handleMouseDownOnSelectorScaleSECircleEl.js";
import { _handleMouseDownOnSelectorScaleSWCircleEl } from "../private/_handleMouseDownOnSelectorScaleSWCircleEl.js";
import { _handleMouseMove } from "../private/_handleMouseMove.js";
import { _handleMouseUp } from "../private/_handleMouseUp.js";
import { addEl } from "../private/addEl.js";
import { calculateViewBoxFitToArtBoard } from "../private/calculateViewBoxFitToArtBoard.js";
import { PROCESSING_TASK } from "../private/const.js";
import { copyEl } from "../private/copyEl.js";
import { destroy } from "../private/destroy.js";
import { initEditor } from "../private/initEditor.js";
export class FreeStickerPCEditor {
  constructor({ window, document, max_count }) {
    this._window = window;
    this._document = document;
    this._svg_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "svg"
    );
    this._transform_manipulator = new TransformNS.ModelNS.TransformManipulator({
      svg_el: this._svg_el,
    });
    if (!Number.isSafeInteger(max_count)) {
      throw new Error(`max_count 값이 안전한 정수가 아닙니다.`);
    }
    if (max_count < 1) {
      throw new Error(`max_count 값이 자연수가 아닙니다.`);
    }
    this._max_count = max_count;
    this._container_el = null;
    this._canvas_el = null;
    this._dummy_g_el = null;
    this._layers_el = null;
    this._art_board_layer_el = null;
    this._background_layer_el = null;
    this._template_layer_el = null;
    this._working_layer_el = null;
    this._foreground_layer_el = null;
    this._rubber_band_layer_el = null;
    this._art_board_rect_el = null;
    this._art_board_filter_drop_shadow_el = null;
    this._background_base_el = null;
    this._background_color_el = null;
    this._background_image_el = null;
    this._selector_path_el = null;
    this._selector_nw_circle_el = null;
    this._selector_ne_circle_el = null;
    this._selector_se_circle_el = null;
    this._selector_sw_circle_el = null;
    this._selector_r_circle_el = null;
    this._rubber_band_el = null;
    this._view_port = null;
    this._view_box = null;
    this._background = null;
    this._art_board = null;
    this._rubber_band = null;
    this._selector_controller = null;
    this._translate_transforming = null;
    this._rotate_transforming = null;
    this._scale_transforming1 = null;
    this._translate_transform = null;
    this._els = new Map();
    this._selected_el_ids = new Set();
    this._processing_task = null;
    this._mouseDownOnCanvasElHandler = null;
    this._mouseDownOnSelectorPathElHandler = null;
    this._mouseDownOnSelectorScaleNECircleElHandler = null;
    this._mouseDownOnSelectorScaleSECircleElHandler = null;
    this._mouseDownOnSelectorScaleSWCircleElHandler = null;
    this._mouseDownOnSelectorScaleNWCircleElHandler = null;
    this._mouseDownOnSelectorRotateCircleElHandler = null;
    this._mouseMoveHandler = null;
    this._mouseUpHandler = null;
    this._mouse_down_position = null;
    this._rotate_transforming_origin_x = 0;
    this._rotate_transforming_origin_y = 0;
  }
  initDOM() {
    return BaseNS.initDOM(this);
  }
  initEditor() {
    return initEditor(this);
  }
  destroy() {
    return destroy(this);
  }
  appendTo(container_el) {
    return BaseNS.appendTo(this, container_el);
  }
  fitSize() {
    return BaseNS.fitSize(this);
  }
  setArtBoardSize(size) {
    return BaseNS.setArtBoardSize(this, size);
  }
  calculateViewBoxFitToArtBoard(config) {
    return calculateViewBoxFitToArtBoard(this, config);
  }
  setViewBox(view_box_vo) {
    return BaseNS.setViewBox(this, view_box_vo);
  }
  getIsFull() {
    return BaseNS.getIsFull(this);
  }
  addEl(el_payload) {
    return addEl(this, el_payload);
  }
  removeEl(id) {
    return BaseNS.removeEl(this, id);
  }
  copyEl(id) {
    return copyEl(this, id);
  }
  selectEls(ids) {
    return BaseNS.selectEls(this, ids);
  }
  getBackground() {
    return BaseNS.getBackground(this);
  }
  setBackground(background_value_vo) {
    return BaseNS.setBackground(this, background_value_vo);
  }
  getEls() {
    return BaseNS.getEls(this);
  }
  getSelectedEls() {
    return BaseNS.getSelectedEls(this);
  }
  translateEl(payload) {
    return BaseNS.translateEl(this, payload);
  }
  setCuttingLineStrokeStyle(payload) {
    return BaseNS.setCuttingLineStrokeStyle(this, payload);
  }
  resetCuttingLineStrokeStyle(payload) {
    return BaseNS.resetCuttingLineStrokeStyle(this, payload);
  }
  setForeground(foreground_el) {
    return BaseNS.setForeground(this, foreground_el);
  }
  unsetForeground() {
    return BaseNS.unsetForeground(this);
  }
  setTemplate(template_el) {
    return BaseNS.setTemplate(this, template_el);
  }
  unsetTemplate() {
    return BaseNS.unsetTemplate(this);
  }
  exportEditor(factor) {
    return BaseNS.exportEditor(this, factor);
  }
  _handleMouseDownOnCanvasEl(event) {
    return _handleMouseDownOnCanvasEl(this, event);
  }
  _handleMouseDownOnSelectorPathEl(event) {
    return _handleMouseDownOnSelectorPathEl(this, event);
  }
  _handleMouseDownOnSelectorScaleNECircleEl(event) {
    return _handleMouseDownOnSelectorScaleNECircleEl(this, event);
  }
  _handleMouseDownOnSelectorScaleSECircleEl(event) {
    return _handleMouseDownOnSelectorScaleSECircleEl(this, event);
  }
  _handleMouseDownOnSelectorScaleSWCircleEl(event) {
    return _handleMouseDownOnSelectorScaleSWCircleEl(this, event);
  }
  _handleMouseDownOnSelectorScaleNWCircleEl(event) {
    return _handleMouseDownOnSelectorScaleNWCircleEl(this, event);
  }
  _handleMouseDownOnSelectorScaleCircleEl(payload) {
    return _handleMouseDownOnSelectorScaleCircleEl(this, payload);
  }
  _handleMouseDownOnSelectorRotateCircleEl(event) {
    return _handleMouseDownOnSelectorRotateCircleEl(this, event);
  }
  _handleMouseMove(event) {
    return _handleMouseMove(this, event);
  }
  _handleMouseUp(event) {
    return _handleMouseUp(this, event);
  }
  _getSelectorCenterPointInViewPort() {
    return BaseNS._getSelectorCenterPointInViewPort(this);
  }
  _getContainerElThrowable() {
    return BaseNS._getContainerElThrowable(this);
  }
  _getCanvasElThrowable() {
    return BaseNS._getCanvasElThrowable(this);
  }
  _getDummyGElThrowable() {
    return BaseNS._getDummyGElThrowable(this);
  }
  _getLayersElThrowable() {
    return BaseNS._getLayersElThrowable(this);
  }
  _getArtBoardLayerElThrowable() {
    return BaseNS._getArtBoardLayerElThrowable(this);
  }
  _getBackgroundLayerElThrowable() {
    return BaseNS._getBackgroundLayerElThrowable(this);
  }
  _getTemplateLayerElThrowable() {
    return BaseNS._getTemplateLayerElThrowable(this);
  }
  _getWorkingLayerElThrowable() {
    return BaseNS._getWorkingLayerElThrowable(this);
  }
  _getForegroundLayerElThrowable() {
    return BaseNS._getForegroundLayerElThrowable(this);
  }
  _getRubberBandLayerElThrowable() {
    return BaseNS._getRubberBandLayerElThrowable(this);
  }
  _getArtBoardRectElThrowable() {
    return BaseNS._getArtBoardRectElThrowable(this);
  }
  _getArtBoardFilterDropShadowElThrowable() {
    return BaseNS._getArtBoardFilterDropShadowElThrowable(this);
  }
  _getBackgroundBaseElThrowable() {
    return BaseNS._getBackgroundBaseElThrowable(this);
  }
  _getBackgroundColorElThrowable() {
    return BaseNS._getBackgroundColorElThrowable(this);
  }
  _getBackgroundImageElThrowable() {
    return BaseNS._getBackgroundImageElThrowable(this);
  }
  _getSelectorPathElThrowable() {
    return BaseNS._getSelectorPathElThrowable(this);
  }
  _getSelectorNWCircleElThrowable() {
    return BaseNS._getSelectorNWCircleElThrowable(this);
  }
  _getSelectorNECircleElThrowable() {
    return BaseNS._getSelectorNECircleElThrowable(this);
  }
  _getSelectorSECircleElThrowable() {
    return BaseNS._getSelectorSECircleElThrowable(this);
  }
  _getSelectorSWCircleElThrowable() {
    return BaseNS._getSelectorSWCircleElThrowable(this);
  }
  _getSelectorRCircleElThrowable() {
    return BaseNS._getSelectorRCircleElThrowable(this);
  }
  _getRubberBandElThrowable() {
    return BaseNS._getRubberBandElThrowable(this);
  }
  _getViewPortThrowable() {
    return BaseNS._getViewPortThrowable(this);
  }
  _getViewBoxThrowable() {
    return BaseNS._getViewBoxThrowable(this);
  }
  _getBackgroundThrowable() {
    return BaseNS._getBackgroundThrowable(this);
  }
  _getArtBoardThrowable() {
    return BaseNS._getArtBoardThrowable(this);
  }
  _getRubberBandThrowable() {
    return BaseNS._getRubberBandThrowable(this);
  }
  _getSelectorControllerThrowable() {
    return BaseNS._getSelectorControllerThrowable(this);
  }
  _getTranslateTransformingThrowable() {
    return BaseNS._getTranslateTransformingThrowable(this);
  }
  _getRotateTransformingThrowable() {
    return BaseNS._getRotateTransformingThrowable(this);
  }
  _getScaleTransforming1Throwable() {
    return BaseNS._getScaleTransforming1Throwable(this);
  }
  _getTranslateTransformThrowable() {
    return BaseNS._getTranslateTransformThrowable(this);
  }
  _checkNoProcessingTask() {
    /** @todo */
  }
  _toViewPortPoint(point) {
    return BaseNS._toViewPortPoint(this, point);
  }
}
